import React from "react";
import { TooltipIcon } from "components/InputCards/TooltipIcon";
import { NumberInput } from "components/Inputs/NumberInput/NumberInput";
import type {
  OrderCodePartOptionStrict,
  OrderCodePartStrict,
} from "stores/product";
import type { OnChange } from "../OrderCodePartOption";

type RangeInputComponentProps = {
  value: number;
  onChange: OnChange;
  label?: string;
  description?: string;
  disabled?: boolean;
  min: number;
  max: number;
  testId?: string;
};

const RangeInputComponent = ({
  description,
  label,
  value,
  onChange,
  disabled,
  max,
  min,
  testId,
}: RangeInputComponentProps) => {
  return (
    <>
      <TooltipIcon description={description} />
      {label && <h5>{label}</h5>}
      <div className="d-flex flex-nowrap align-items-center">
        <NumberInput
          initialValue={+value}
          onSave={onChange}
          min={min}
          max={max}
          disabled={disabled}
          classNames="w-100"
          allowOutsidePropagation={false}
          testId={testId}
        />
        <span
          className="ms-2 font-size-sm text-gray-500 text-end"
          style={{ minWidth: "70px" }}
        >
          {min}&nbsp;...&nbsp;{max}
        </span>
      </div>
    </>
  );
};

export const RangeInput = ({
  option,
  disabled,
  onChange,
  part,
}: {
  option: OrderCodePartOptionStrict;
  disabled: boolean;
  onChange: OnChange;
  part: OrderCodePartStrict;
}) => {
  if (
    !option.range ||
    option?.range?.min === null ||
    option?.range?.max === null
  ) {
    console.error("Option has invalid range data:", option);
    return <></>;
  }
  return (
    <RangeInputComponent
      label={option.title ?? undefined}
      value={Number(option.currentSignature?.value)}
      max={option.range?.max ?? 0}
      min={option.range?.min ?? 0}
      disabled={disabled}
      onChange={onChange}
      testId={`range-input-${part.key}-${option.key}`}
    />
  );
};
